<template>
  <div class="mainContainer blaMessagesContainer">
    <!-- ERROR SNIPPET -->
    <v-snackbar
      v-model="error.show"
      color="error"
      top
      :timeout="error.timeout"
      text-xs-center
    >
      {{ error.message }}
      <v-icon right dark>error_outline</v-icon>
    </v-snackbar>

    <div class="row">
      <div class="col-10 offset-1 col-md-8 offset-md-2">
        <div class="row mt-4">
          <div class="col-12 col-md-3 blaMessagesListBox">
            <div class="blaMessagesTitleAlt">
              Beszélgetések
            </div>
            <hr />
            <div
              class="row clickable"
              v-for="(message, index) in messages"
              :key="index"
              overflow
              height="90%"
              @click="loadMessage(message)"
            >
              <div class="col-2">
                <img
                  v-if="message.user.profile_photo != null"
                  :src="
                    apiUrl +
                      '/uploads/profile_photos/' +
                      message.user.profile_photo
                  "
                  :alt="message.user.name"
                  class="blaMessagesListPhoto"
                />
                <img
                  v-else
                  :src="apiUrl + '/uploads/profile_photos/default.png'"
                  :alt="message.user.name"
                  class="blaMessagesListPhoto"
                />
              </div>
              <div class="col-8 offset-1 blaMessagesListTitle">
                {{ message.items[0].title }}
              </div>
            </div>
          </div>
          <div
            class="col-12 col-md-8 offset-0 offset-md-1"
            @show="conversationShow"
          >
            <div
              class="row mt-4 mt-md-0"
              v-for="(item, index) in messageItems"
              :key="index"
            >
              <div :class="renderFlex(item)">
                <div class="row align-end mb-4">
                  <div :class="renderAvatar(item)">
                    <img
                      v-if="item.user.profile_photo !== null"
                      :src="
                        apiUrl +
                          '/uploads/profile_photos/' +
                          item.user.profile_photo
                      "
                      :alt="item.user.name"
                      class="blaMessagesPhoto"
                    />
                    <img
                      v-else
                      :src="apiUrl + '/uploads/profile_photos/default.png'"
                      :alt="item.user.name"
                      class="blaMessagesPhoto"
                    />
                  </div>
                  <div :class="renderCardFlex(item)">
                    <!--<div :class="renderName(item)" class="text-muted">-->
                    <!--  {{ item.user.name }}-->
                    <!--</div>-->
                    <div :class="renderCard(item)">
                      <div v-html="item.message"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-10 offset-1 col-md-8 offset-md-2 blaMessagesInputContainer"
        v-if="conversationShow"
      >
        <div class="row align-center">
          <div class="col-10">
            <input type="text" class="blaMessagesInputTextField" v-model="newMessage" placeholder="Írj üzenetet..."/>
          </div>
          <div class="col-2 text-center">
            <img
              :src="require('@/assets/img/message-send-button.png')"
              alt="sendButton"
              class="blaMessagesSendButton clickable"
              @click="sendMessage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  components: {},
  data: function() {
    return {
      apiUrl: this.$store.getters.getApiUrl,
      userId: this.$store.getters.currentUser.id,
      messages: '',
      messageItems: '',
      newMessage: '',
      currentMessage: '',
      conversationShow: false,
      sendInputShow: false,
      success: {
        show: false,
        message: '',
        timeout: 4500
      },
      error: {
        show: false,
        message: '',
        timeout: 4500
      }
    };
  },
  methods: {
    getMessages() {
      axios
        .post(this.$store.getters.getApiUrl + '/api/message/getMessages', {
          token: this.$store.getters.getToken,
          userId: this.$store.getters.currentUser.id
        })
        .then(response => {
          // console.log('messages-get-resp: ', response.data.messagesData);
          this.$data.messages = response.data.messagesData;
        })
        .catch(error => {
          if (error.length > 0) {
            console.log('profile- error: ', error);
          }

          var v = this;
          setTimeout(function() {
            v.$data.loader = false;
          }, 1000);
        });
    },
    loadMessage(message) {
      // console.log(message);
      axios
        .post(
          this.$store.getters.getApiUrl + '/api/message/getMessageDetails',
          {
            token: this.$store.getters.getToken,
            userId: this.$store.getters.currentUser.id,
            messageId: message.id
          }
        )
        .then(response => {
          // console.log('messagesDetails-get-resp: ', response.data.messagesData);
          this.$data.messages = response.data.messagesData;
          this.$data.messageItems = response.data.messageItems;

          //After we load the messageDetails, show them
          this.$data.conversationShow = true;
          this.$data.sendInputShow = true;
          this.$data.currentMessage = message.id;
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log('profile- error: ', error);
          }

          var v = this;
          setTimeout(function() {
            v.$data.loader = false;
          }, 1000);
        });
    },
    renderFlex(item) {
      if (this.userId !== item.user.id) {
        return 'col-12 col-md-8';
      } else {
        return 'col-12 offset-md-4 col-md-8';
      }
    },
    renderCard(item) {
      if (this.userId !== item.user.id) {
        return 'blaMessagesBox blaMessagesBoxLeft';
      } else {
        return 'blaMessagesBox blaMessagesBoxRight';
      }
    },
    renderCardFlex(item) {
      if (this.userId !== item.user.id) {
        return 'col-10 offset-1 order-2';
      } else {
        return 'col-10 order-1';
      }
    },
    renderAvatar(item) {
      if (this.userId !== item.user.id) {
        return 'col-1 order-1 text-xs-right pl-1';
      } else {
        return 'col-1 order-2';
      }
    },
    renderName(item) {
      if (this.userId !== item.user.id) {
        return 'text-xs-left';
      } else {
        return 'text-xs-right';
      }
    },
    sendMessage() {
      axios
        .post(this.$store.getters.getApiUrl + '/api/message/sendMessage', {
          token: this.$store.getters.getToken,
          userId: this.$store.getters.currentUser.id,
          messageId: this.$data.currentMessage,
          newMessage: this.newMessage
        })
        .then(response => {
          // console.log('messages-send-resp: ', response.data.messagesData);
          this.$data.messages = response.data.messagesData;
          this.$data.messageItems = response.data.messageItems;

          //After we load the messageDetails, show them
          this.$data.conversationShow = true;
          this.$data.currentMessage = message.id;
          this.$data.newMessage = ''; //Empty new message
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log('profile- error: ', error);
          }

          var v = this;
          setTimeout(function() {
            v.$data.loader = false;
          }, 1000);
        });
    }
  },
  mounted: function() {
    this.getMessages();
  }
};
</script>
